module.exports = __webpack_public_path__ + "static/media/long-form-cta-background.9f39cf18.webp";